import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BillingModule } from '../billing/billing.module';
import { ProgressModule } from '../progress/progress.module';
import { SystemInformationModule } from '../systeminformation/systeminformation.module';
import { AboutDialogComponent } from './about/about-dialog.component';
import { BillingDialog } from './billing/billing-dialog.component';
import { DeleteModal } from './modal-delete.component';
import { ShowErrorModal } from './modal-error.component';
import { LoadingModal } from './modal-loading.component';
import { SupportDialogComponent } from './support/support-dialog.component'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ProgressModule,
        SystemInformationModule,
        BillingModule
    ],
    declarations: [
        ShowErrorModal,
        DeleteModal,
        LoadingModal,
        AboutDialogComponent,
        SupportDialogComponent,
        BillingDialog
    ],
    entryComponents: [
        AboutDialogComponent,
        BillingDialog
    ],
    exports: [
        ShowErrorModal,
        DeleteModal,
        LoadingModal,
        AboutDialogComponent,
        SupportDialogComponent,
        BillingDialog
    ],
})
export class ModalsModule { }



// WEBPACK FOOTER //
// ./src/app/modals/modals.module.ts